
import { Template, LazyTemplate } from "../../core/template/index";
import { View } from "../../core/view";
import { TestDynamicallyAddedRemovedButton } from "../../app/actionbar";
import { ActionBarItem } from "../../core/action-bar/item";

export default class TestView extends View
{
    public template = Template.lazy('/views/test/index.html');   

    public data = {
        gender: 'female'
    }

    private item: ActionBarItem;

    constructor(data?: any)
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        this.app.actionBar.add(TestDynamicallyAddedRemovedButton).then((item) =>
        {
            this.item = item;
        });

        return super.beforeRender();
    }

    public unload(): PromiseLike<void>
    {
        if (this.item !== undefined)
        {
            this.item.remove();
        }
    
        return super.unload();
    }
}